/* @flow */
// typecheck: ignore file
import React from 'react';
import { Link as RouterLink } from 'react-router';

import createChainedFunction from 'utils/createChainedFunction';

/**
 * Base link component that encapsulates logic for `react-router`
 *
 * This component is by [Link](/components/Link). You should almost always use Link, unless you
 * want to style your link differently.
 */

class LinkBase extends React.Component {
  static propTypes = {
    children: React.PropTypes.node.isRequired,
    href: React.PropTypes.string,
    target: React.PropTypes.string,
    onClick: React.PropTypes.func,
    to: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.object,
    ]),
    'data-test-selector': React.PropTypes.string,
    activeClassName: React.PropTypes.string,
    onlyActiveOnIndex: React.PropTypes.bool,
    download: React.PropTypes.bool,
    rel: React.PropTypes.string,
    disabled: React.PropTypes.bool,
  };

  handleClick = (event: SyntheticMouseEvent) => {
    if (!this.props.to && !this.props.href || this.props.href === '#') {
      event.preventDefault();
    }
  };

  render() {
    let link;
    const {
      to,
      className,
      href,
      target,
      children,
      rel,
      onClick,
      onDragEnd,
      activeClassName,
      onMouseEnter,
      onMouseLeave,
      onMouseMove,
      onlyActiveOnIndex,
      download,
      disabled,
    } = this.props;

    if (to) {
      link = (
        <RouterLink
          target={target}
          disabled={disabled}
          activeClassName={activeClassName}
          onlyActiveOnIndex={onlyActiveOnIndex}
          data-test-selector={this.props['data-test-selector']}
          to={to}
          className={className}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onMouseMove={onMouseMove}
          onDragEnd={onDragEnd}
          onClick={createChainedFunction(onClick, this.handleClick)}>
          {children}
        </RouterLink>
      );
    } else {
      link = (
        <a
          data-test-selector={this.props['data-test-selector']}
          className={className}
          href={typeof href === 'undefined' ? '#' : href}
          target={target}
          disabled={disabled}
          download={download}
          rel={rel}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onMouseMove={onMouseMove}
          onDragEnd={onDragEnd}
          onClick={createChainedFunction(onClick, this.handleClick)}>
          {children}
        </a>
      );
    }

    return link;
  }
}

export default LinkBase;



// WEBPACK FOOTER //
// ./src/components/LinkBase.jsx